/**
 * @generated SignedSource<<eb49a3268c9ad8c8a1cd79d3bbd129f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeTextFormBrand$data = {
  readonly facebookPages: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly instagramAccounts: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "CreativeTextFormBrand";
};
export type CreativeTextFormBrand$key = {
  readonly " $data"?: CreativeTextFormBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeTextFormBrand">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeTextFormBrand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacebookPage",
      "kind": "LinkedField",
      "name": "facebookPages",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InstagramAccount",
      "kind": "LinkedField",
      "name": "instagramAccounts",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};
})();

(node as any).hash = "ed181693b26a5f46aff9c8f107eeff6a";

export default node;
